/**
 * Private modules
 */
const {
  createQueryComponent,
  objectId,
} = require('../.private').components;

module.exports = {
  getSystemById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
